import {
  ASSETS_AND_IR_DETAILS,
  generateBFFUrl,
  SERVICE_BOOKING_ELIGIBILITY,
} from '@/configs/apiEndPoints';
import axiosInstance from './axiosConfig';
import { AxiosResponse } from 'axios';
import { GenericError } from '@/errors/GenericServerError';
import generateHttpHeaders from './axiosConfig/generateHttpHeaders';
import { AssetsData } from '@/types/asset';

export const fetchServiceBookingEligibility = async (assetId: string): Promise<any> => {
  try {
    return await axiosInstance.get(generateBFFUrl(SERVICE_BOOKING_ELIGIBILITY), {
      params: { assetId },
    });
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError('Something went wrong', status, statusText, data);
  }
};

export const fetchIRAndAssetsDetails = async (serverCookie?: any): Promise<any> => {
  try {
    const response = await axiosInstance.get(generateBFFUrl(ASSETS_AND_IR_DETAILS), {
      headers: generateHttpHeaders(serverCookie),
    });
    return response?.data?.data;
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError('Something went wrong', status, statusText, data);
  }
};
